import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import ScrollToTop from "./components/_app/ScrollToTop";
import Router from "./routes/Router";
import { initGA, trackPageview } from "./utils/analytics";

function App() {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics with the Measurement ID from environment variables
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    initGA(measurementId);
  }, []);

  useEffect(() => {
    // Track page view on route changes
    trackPageview(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <ToastContainer />
      <ScrollToTop />
      <Router />
    </>
  );
}

export default App;
